export default __webpack_public_path__ + "static/media/submissions.fff75041.svg";